import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full py-10 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-medium mt-2 mb-5 text-center" }, "Vas a salir de TRecupera, ¿Deseas continuar?")
], -1)
const _hoisted_3 = { class: "w-8/12 grid grid-cols-2 gap-2 items-center mx-auto" }
const _hoisted_4 = { class: "w-full flex flex-col items-center mx-auto" }
const _hoisted_5 = { class: "w-full flex flex-col items-center mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sirit_modal = _resolveComponent("sirit-modal")!

  return (_openBlock(), _createBlock(_component_sirit_modal, { size: "sm" }, {
    modalContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal())),
              type: "submit",
              class: "w-full mt-4 py-2 md:px-6 rounded-md border-2 border-black hover:bg-gray-100 text-black font-bold"
            }, "Cancelar")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.logout())),
              type: "submit",
              class: _normalizeClass(["w-full mt-4 py-2 md:px-6 text-white rounded-md border-2", `bg-${$setup.colors.primary}-500 hover:bg-${$setup.colors.primary}-600`])
            }, "Aceptar", 2)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}